import Component from '../Component';
import Alertify from 'alertify.js';

export default class Dialog extends Component {

  configure() {
    this.provider = Alertify;
    this.dialog = null;
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

  }

  alert(message) {
    this.logger('Alert with message:', message);

    this.provider.okBtn(
      this.App.Language.get('_.ok')
    ).alert(message);

    return this;
  }

  confirm(message, onConfirm, onCancel) {
    this.logger('Confirm opened with message:', message);

    this
      .provider
      .okBtn(
        this.App.Language.get('_.ok')
      ).cancelBtn(
        this.App.Language.get('_.cancel')
      ).confirm(message, onConfirm, onCancel);

    return this;
  }

}